import React from "react";
import "./Lines.css";

import LinesOne from "./LinesOne";
import LinesTwo from "./LinesTwo";


function Lines() {
  return (
    <React.Fragment>
        <LinesTwo />
        <LinesOne />
    </React.Fragment>
  )
}

export default Lines;
